<div class="header-container surface">
  <div class="header-left">
    <div class="header-logo" [class.header-logo-light]="isLightTheme()" [class.header-logo-dark]="!isLightTheme()"></div>
  </div>
  <div class="header-right">
    <div class="user-area" *ngIf="(user$ | async) as user; else loginTpl">
      <button #langButton type="button" class="lang-button" (click)="toggleLangMenu()" [attr.aria-expanded]="isLangMenuOpen()">
        <span class="material-symbols-outlined" aria-hidden="true">language</span>
      </button>
      <div #langMenu class="lang-menu" *ngIf="isLangMenuOpen()">
        <div *ngFor="let l of languages" class="lang-item" [attr.aria-current]="currentLanguage() === l.code ? 'true' : 'false'">
          <ng-container *ngIf="currentLanguage() === l.code; else switchLangTpl">
            <span>{{ l.labelKey | translate }}</span>
            <span class="material-symbols-outlined check-icon" aria-hidden="true">check</span>
          </ng-container>
          <ng-template #switchLangTpl>
            <button type="button" (click)="selectLanguage(l.code)">{{ l.labelKey | translate }}</button>
          </ng-template>
        </div>
      </div>
      <div #avatarButton class="avatar" (click)="toggleUserMenu()" [style.background-image]="'url(' + (user.picture || '') + ')'" [attr.title]="('header.account' | translate)"></div>
      <div #userMenu class="menu-panel" *ngIf="isMenuOpen()">
        <div class="user-info">
          <div class="name">{{ user.name || user.nickname }}</div>
          <div class="email">{{ user.email }}</div>
        </div>
        <button type="button" class="button" (click)="toggleTheme()">
          {{ (isLightTheme() ? ('header.dark' | translate) : ('header.light' | translate)) }}
        </button>
        <button type="button" class="button" (click)="logout()">{{ 'header.logout' | translate }}</button>
      </div>
    </div>
    <ng-template #loginTpl>
      <button type="button" class="button" (click)="login()">{{ 'header.login' | translate }}</button>
    </ng-template>
  </div>
</div>
